import { useEffect } from "react";
import { useQuery } from "~hooks/useQuery";
import {
  EventAccessStatus,
  GetEventAndReleaseForCustomerDocument,
} from "~graphql/typed-document-nodes";
import { getError, showToast } from "~lib";
import { useRouter } from "next/router";
import { ToastType } from "react-toastify";

type QueryParams = {
  eventId?: string;
  releaseId?: string;
  slug?: string;
};
export const useEventAccessControl = () => {
  const router = useRouter();

  const { eventId, slug } = router.query as QueryParams;

  const releaseId = router.query.release as string;

  const { isLoading, data, error, isValidating } = useQuery(
    GetEventAndReleaseForCustomerDocument,
    {
      input: { eventId, releaseId, releaseSlug: slug },
    }
  );

  const { event, release, isAdmin, accessType } =
    data?.getEventAndReleaseForCustomer ?? {};

  useEffect(() => {
    if (getError(error, "graphQL") === EventAccessStatus.Denied) {
      void router.push("/");
      void showToast(
        "This event is not public. Admin only access.",
        ToastType.ERROR
      );
    }
    if (getError(error, "graphQL") === EventAccessStatus.EventEnded) {
      void router.push("/");
      void showToast("This event has finished.", ToastType.ERROR);
    }
  }, [error]);

  return {
    isLoading,
    release,
    isAdmin,
    event,
    error,
    isValidating,
    accessType,
  };
};
